var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewsWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.394,
    height: 45.348,
    viewBox: "0 0 51.394 45.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "news",
    transform: "translate(0 -26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(0 26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M72.907,336H61.163a1.163,1.163,0,1,0,0,2.326H72.907a1.163,1.163,0,1,0,0-2.326Z",
    transform: "translate(-53.023 -299.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M223.907,336H212.163a1.163,1.163,0,0,0,0,2.326h11.744a1.163,1.163,0,0,0,0-2.326Z",
    transform: "translate(-186.466 -299.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M90.464,86h-29.3a1.163,1.163,0,1,0,0,2.326h29.3a1.163,1.163,0,0,0,0-2.326Z",
    transform: "translate(-53.023 -79.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M223.907,136H212.163a1.163,1.163,0,0,0,0,2.326h11.744a1.163,1.163,0,1,0,0-2.326Z",
    transform: "translate(-186.466 -123.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M223.907,186H212.163a1.163,1.163,0,0,0,0,2.326h11.744a1.163,1.163,0,0,0,0-2.326Z",
    transform: "translate(-186.466 -167.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M223.907,236H212.163a1.163,1.163,0,0,0,0,2.326h11.744a1.163,1.163,0,0,0,0-2.326Z",
    transform: "translate(-186.466 -211.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M223.907,286H212.163a1.163,1.163,0,1,0,0,2.326h11.744a1.163,1.163,0,0,0,0-2.326Z",
    transform: "translate(-186.466 -255.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M72.907,286H61.163a1.163,1.163,0,1,0,0,2.326H72.907a1.163,1.163,0,1,0,0-2.326Z",
    transform: "translate(-53.023 -255.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M72.907,136H61.163A1.163,1.163,0,0,0,60,137.163v11.744a1.163,1.163,0,0,0,1.163,1.163H72.907a1.163,1.163,0,0,0,1.163-1.163V137.163A1.163,1.163,0,0,0,72.907,136Zm-1.163,11.744H62.326v-9.418h9.418Z",
    transform: "translate(-53.023 -123.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M49.068,31.814H45.58V28.326A2.328,2.328,0,0,0,43.254,26H2.326A2.328,2.328,0,0,0,0,28.326V65.534a5.82,5.82,0,0,0,5.814,5.814H45.58a5.82,5.82,0,0,0,5.814-5.814V34.139A2.328,2.328,0,0,0,49.068,31.814Zm0,33.72a3.492,3.492,0,0,1-3.488,3.488H5.814a3.492,3.492,0,0,1-3.488-3.488V28.326H43.254V63.789A2.91,2.91,0,0,0,46.161,66.7a1.163,1.163,0,0,0,0-2.326.582.582,0,0,1-.581-.581V34.139h3.488Z",
    transform: "translate(0 -26)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsWhiteLogo);
export default __webpack_public_path__ + "static/media/news-white-logo.31b24e120cc8874fc6220818e8b1a4a8.svg";
export { ForwardRef as ReactComponent };